import { mobileNavBarRoutes } from "../../constants/mobileNavBarRoutes";
import clsx from "clsx";
import { useLocation } from "react-router-dom";

import NavigationBar from "../navigation-bar";

import * as styles from "./layout-auth.css";

interface LayoutProps {
  className?: string;
  children: React.ReactNode;
}

export function LayoutAuth({ className, children, ...rest }: LayoutProps) {
  const { pathname } = useLocation();

  return (
    <div
      className={clsx(styles.layout, className)}
      data-testid="layout-auth"
      {...rest}
    >
      <NavigationBar
        withProfileMenu={pathname.startsWith("/chat")}
        withMobileNavBar={mobileNavBarRoutes.some(
          (route) => pathname === route
        )}
        data-testid="layout-navigation-bar"
        logged
      />
      {children}
    </div>
  );
}
